import { selector } from '@poa/state';

export const usersData = selector(store => {
  return store.home.data
});
